export default __webpack_public_path__ + "static/N0031-69f8628edd4f3c11c25efdca459efde6.png";